export const extractRefIds = (refs: Record<string, number | number[] | undefined> | undefined): number[] =>
  refs
    ? Object.values(refs)
        .flatMap((idOrIds) => (Array.isArray(idOrIds) ? idOrIds : [idOrIds]))
        .filter((id): id is NonNullable<typeof id> => !!id)
    : [];
